import React from 'react';
import { cn } from '../../utils/cn';

export interface TagProps {
  children: React.ReactNode;
  variant?: 'default' | 'velux' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
}

const Tag: React.FC<TagProps> = ({
  children,
  variant = 'velux',
  size = 'sm',
  className,
  onClick,
}) => {
  const baseClasses = 'inline-flex items-center font-semibold rounded transition-colors';

  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    velux: 'bg-velux-ui-grey text-velux-black',
    secondary: 'bg-velux-blue text-white',
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  const Component = onClick ? 'button' : 'span';

  return (
    <Component
      onClick={onClick}
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        onClick && 'cursor-pointer hover:opacity-80',
        className
      )}
    >
      {children}
    </Component>
  );
};

Tag.displayName = 'Tag';

export { Tag };